import React from 'react'

import { MetaText, HeadingSmall, StatusText, Content, MediaContainer } from '@pb/components'
import { formatCurrency, formatDate } from '@pb/utils'

import getStatusType from 'helpers/getStatusType'

const OrderHeader: React.FC<any> = ({
  orderCreatedAt,
  orderDueDate,
  orderAmount,
  orderStatus,
  orderStatusDescription,
}) => {
  return (
    <MediaContainer>
      <Content>
        <HeadingSmall Tag="p">{formatCurrency(orderAmount / 100)}</HeadingSmall>
        <MetaText Tag="time">{formatDate(orderCreatedAt)}</MetaText>
        {orderStatusDescription && (
          <StatusText type={getStatusType(orderStatus, orderDueDate)} icon>
            {orderStatusDescription}
          </StatusText>
        )}
      </Content>
    </MediaContainer>
  )
}

export default OrderHeader
